import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  // useEffect,
} from 'react';
import {
  fetchClaimsByPolicyNumber,
  getClaimDetails,
  /*getAllClaims,*/
} from '../services/claimsService';
import { ClaimDetails, ClaimEntity } from '../types';

interface ClaimsContextType {
  claims: ClaimEntity[];
  loadingClaims: boolean;
  errorClaims: string | null;
  selectedClaimId: string | null;
  selectedClaimDetails: ClaimDetails | null;
  loadingClaimDetails: boolean;
  errorClaimDetails: string | null;
  // fetchClaims: () => Promise<void>;
  fetchClaimDetails: (claimId: string) => Promise<void>;
  selectClaim: (claimId: string) => void;
  getClaimsByPolicyNumber: (policyNumber: string) => Promise<ClaimEntity[]>;
}

const ClaimsContext = createContext<ClaimsContextType | null>(null);

export const ClaimsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [claims, setClaims] = useState<ClaimEntity[]>([]);
  const [loadingClaims, setLoadingClaims] = useState<boolean>(false);
  const [errorClaims, setErrorClaims] = useState<string | null>(null);

  const [selectedClaimId, setSelectedClaimId] = useState<string | null>(null);
  const [selectedClaimDetails, setSelectedClaimDetails] =
    useState<ClaimDetails | null>(null);
  const [loadingClaimDetails, setLoadingClaimDetails] =
    useState<boolean>(false);
  const [errorClaimDetails, setErrorClaimDetails] = useState<string | null>(
    null
  );

  // // Fetch all claims
  // const fetchClaims = async () => {
  //   setLoadingClaims(true);
  //   setErrorClaims(null);
  //   try {
  //     const data = await getAllClaims();
  //     setClaims(data as ClaimEntity[]);
  //   } catch (error) {
  //     console.error('Error fetching claims:', error);
  //     setErrorClaims('Failed to fetch claims. Please try again.');
  //   } finally {
  //     setLoadingClaims(false);
  //   }
  // };

  const fetchClaimDetails = async (claimId: string) => {
    setLoadingClaimDetails(true);
    setErrorClaimDetails(null);
    try {
      const data = await getClaimDetails(claimId);
      setSelectedClaimDetails(data);
      setSelectedClaimId(claimId);
    } catch (error) {
      setErrorClaimDetails('Failed to fetch claim details. Please try again.');
    } finally {
      setLoadingClaimDetails(false);
    }
  };

  // Select a claim by ID
  const selectClaim = (claimId: string) => {
    setSelectedClaimId(claimId);
    // fetchClaimDetails(claimId);
  };

  // Checked by human!
  const getClaimsByPolicyNumber = async (
    policyNumber: string
  ): Promise<ClaimEntity[]> => {
    setLoadingClaims(true);
    try {
      const claimsByPolicy = await fetchClaimsByPolicyNumber(policyNumber);
      setClaims(claimsByPolicy);
      setLoadingClaims(false);
      return claimsByPolicy;
    } catch (error) {
      setLoadingClaims(false);
      setErrorClaims('Failed to fetch claims for the specified policy number.');
    }
    return [];
  };

  // Fetch claims on component mount
  // useEffect(() => {
  //   fetchClaims();
  // }, []);

  return (
    <ClaimsContext.Provider
      value={{
        claims,
        loadingClaims,
        errorClaims,
        selectedClaimId,
        selectedClaimDetails,
        loadingClaimDetails,
        errorClaimDetails,
        // fetchClaims,
        fetchClaimDetails,
        selectClaim,
        getClaimsByPolicyNumber,
      }}
    >
      {children}
    </ClaimsContext.Provider>
  );
};

export const useClaims = () => {
  const context = useContext(ClaimsContext);
  if (!context) {
    throw new Error('useClaims must be used within a ClaimsProvider');
  }
  return context;
};
